module.exports = __webpack_public_path__ + "img/veselo-mob.15a8b6f7.png";